export default "__VITE_ASSET__DR1nUk98__"